import api from "./Api";

class TecnicoService {
  GetTecnico(payload) {
    return api.get("/v1/tecnico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTecnico(payload) {
    return api.post("/v1/tecnico/", payload).then((response) => {
      return response.data;
    });
  }

  PutTecnico(payload) {
    return api.put("/v1/tecnico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTecnico(payload) {
    return api.delete("/v1/tecnico/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTecnicoOData(payload) {
    return api.get("/OData/Tecnico" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TecnicoService();
